import { render, staticRenderFns } from "./CertifikatPorociloJavnoPDFIP.vue?vue&type=template&id=48e3d080&scoped=true&"
import script from "./CertifikatPorociloJavnoPDFIP.vue?vue&type=script&lang=js&"
export * from "./CertifikatPorociloJavnoPDFIP.vue?vue&type=script&lang=js&"
import style0 from "./CertifikatPorociloJavnoPDFIP.vue?vue&type=style&index=0&id=48e3d080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e3d080",
  null
  
)

export default component.exports